// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".popup__label {\n  position: relative;\n  display: block;\n  padding: 30px 0 0;\n}\n", "",{"version":3,"sources":["webpack://src/blocks/popup/__label/popup__label.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,cAAc;EACd,iBAAiB;AACnB","sourcesContent":[".popup__label {\n  position: relative;\n  display: block;\n  padding: 30px 0 0;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
